// This file was automatically generated from app.settings.dialog.idProofingQuiz.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.settings.dialog.idProofingQuiz');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.dialog.idProofingQuiz.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8PromptDialogContainer ebs-container-fluid"><h3 class="el8SurveyQuestion" style="font-weight: bold; color: #E98900 !important">Note: You must complete and submit these questions in one sitting within 10 minutes to validate your identity.</h3><form class="ebs-form-horizontal"></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.dialog.idProofingQuiz.questionSet = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8SurveyQuestionWrap"><h3 class="el8SurveyQuestion">', soy.$$escapeHtml(opt_data.text_cleaned), '</h3><ul class="el8ListSpacing">');
  var choiceList6923 = opt_data.choices;
  var choiceListLen6923 = choiceList6923.length;
  for (var choiceIndex6923 = 0; choiceIndex6923 < choiceListLen6923; choiceIndex6923++) {
    var choiceData6923 = choiceList6923[choiceIndex6923];
    output.append('<li class="ebs-list-unstyled"><input type="radio" name="', soy.$$escapeHtml(opt_data.name), '" id="', soy.$$escapeHtml(opt_data.name), '_', soy.$$escapeHtml(choiceIndex6923 + 1), '" value="', soy.$$escapeHtml(choiceIndex6923 + 1), '"><label class="el8NormalText el8LargeFontSize el8SurveyAnswer ml10" for="', soy.$$escapeHtml(opt_data.name), '_', soy.$$escapeHtml(choiceIndex6923 + 1), '">', soy.$$escapeHtml(choiceData6923), '</label></li>');
  }
  output.append('</ul></div>');
  if (!opt_sb) return output.toString();
};
